"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CANCEL_REMINDER_RESPONSE_EXAMPLE = exports.APPOINTMENT_REMINDER_RESPONSE_EXAMPLE = void 0;
exports.APPOINTMENT_REMINDER_RESPONSE_EXAMPLE = {
    id: 'b0000000-0000-0000-0000-000000000001',
    tenantId: '11111111-1111-1111-1111-111111111111',
    appointmentId: '10000000-0000-0000-0000-000000000001',
    channelId: 'a0000000-0000-0000-0000-000000000001',
    scheduledFor: '2026-08-01T08:00:00.000Z',
    status: 'PENDING',
    sentAt: null,
    retryCount: 0,
    lastError: null,
    createdAt: '2026-07-11T09:00:00.000Z',
    updatedAt: '2026-07-11T09:00:00.000Z',
};
exports.CANCEL_REMINDER_RESPONSE_EXAMPLE = {
    ...exports.APPOINTMENT_REMINDER_RESPONSE_EXAMPLE,
    status: 'CANCELLED',
};
//# sourceMappingURL=reminder.response.js.map